const findYourRoute = (() => {
    let container;
    const resultsSections = () => [...container.querySelectorAll("[data-category-content]")]
    const initBlock = el => {
        container = el
        const input = el.querySelector("input");
        const results = el.querySelector('[data-results]');
        const groups = el.querySelectorAll('[data-group]');
        input.addEventListener('keyup',
            debounce(() => {
                let value = input.value;
                const selectedGroups = [...container.querySelectorAll("[data-category-target]")]
                    .filter(x => x.dataset.active === "true")
                    .map(x => x.dataset.categoryTarget);
                filterResults(value, selectedGroups);
                resetCategories()
            }, 500));
        filterResults(input.value)
        resetCategories()
    };
    
    const resetCategories = () => {
        const dataNoResults = document.querySelector("[data-no-results]");
        
        [...container.querySelectorAll("[data-category-target]")]
            .forEach(section => {
                const resultsContainer = container.querySelector(`[data-category-content='${section.dataset.categoryTarget}']`);
                const count = [...resultsContainer.querySelectorAll("[data-result]")]
                    .filter(x => x.dataset.show !== "true" === false)
                    .length;
                section.textContent = section.dataset.categoryTarget + ` (${count})`;    
                
                if(count > 0)
                {
                    section.classList.remove("hidden");
                }
                else
                {
                    section.classList.add("hidden");
                }
                if (resultsContainer.hasAttribute('data-teaser-carousel')){
                    const sliderControls = resultsContainer.querySelector('[data-slider-controls]');
                    if (count <= 3){
                        sliderControls.classList.add('hidden');
                    }else{
                        sliderControls.classList.remove('hidden');
                    }
                }
            })
        const all = container.querySelector('[data-category-all]');
        let allCount = 0;
        container.querySelectorAll("[data-result]").forEach((x) => {
            if (x.dataset.show !== "true" === false){
                allCount++;
            }
        })
        all.textContent = `SHOW ALL (${allCount})`;
        
        if(allCount > 0)
        {
            dataNoResults.style.display = "none"
        }
        else
        {
            dataNoResults.style.display = "block"
        }
    }

    const filterResults = (searchTerm, selectedGroups = []) => {
        resultsSections().forEach(section => {
            if (selectedGroups.some(x => x) === false || selectedGroups.some(x => x === section.dataset.categoryContent)) {
                section.classList.remove("hidden");
            } else {
                section.classList.add("hidden");
            }
        })

        const sections = resultsSections()
            .map(section => {
                const results = [...section.querySelectorAll("[data-result]")]
                    .map(section => {
                        return {section: section, title: section.dataset.result}
                    });

                const showHideSections = results.reduce((acc, section) => {
                    if (section.title.includes(searchTerm.toLowerCase())) {
                        acc.showResults.push(section)
                    } else {
                        acc.hideResults.push(section)
                    }

                    return acc;
                }, {showResults: [], hideResults: []})

                showHideSections.showResults.map(result => {
                    result.section.dataset.show = "true";
                    result.section.setAttribute("aria-hidden","false");
                    return result.section.style.display = "block";
                });
                showHideSections.hideResults.map(result => {
                    result.section.dataset.show = "false";
                    result.section.setAttribute("aria-hidden","true");
                    return result.section.style.display = "none";
                });

                if (showHideSections.showResults.some(x => x) === false) {
                    section.classList.add("hidden")
                } else {
                    if (section.classList.contains("hidden") === false) {
                        section.classList.remove("hidden")
                    }
                }
            });
    }

    return {initBlock};
})();

ControlBinders.register(`[data-find-your-route]`, el => findYourRoute.initBlock(el));